"use client";

import { ErrorScreen } from "@/components/error-screen";

// Root boundary: covers routes outside (console) — the auth pages — which
// would otherwise fall through to Next's bare "Application error" screen.
export default function RootError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    <div className="h-dvh">
      <ErrorScreen error={error} retry={retry} />
    </div>
  );
}
